export default __webpack_public_path__ + "static/media/bookworm-purple.aad509f0.svg";